import React from 'react';

export function AppliedToBadge({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center rounded-xl bg-emerald-50/90 px-6 py-3 text-xl font-gilroy-bold leading-none text-emerald-700 shadow-[0_6px_16px_rgba(16,185,129,0.10)] ring-1 ring-emerald-100">
      {children}
    </span>
  );
}
